import { createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import toast from 'react-hot-toast';

export const ordersSlice = createSlice({
  name: 'orders',
  initialState: {
    searchMRN: '',
    searchAccession: '',
    ordersData: '', 
    Processing: false,
    ErrorMessage: '',
    displayRow:'',
  },
  reducers: {
    updateMRN: (state, action)  => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.searchMRN = action.payload;
    },
    updateAccession: (state, action) => {
      state.searchAccession = action.payload;
    },
    "clearOrdersData": (state, action) => {
      console.log('in clearOrdersDtta');
      state.ordersData = action.payload;
    },
    "orders/updateOrdersData": (state, action) => {
      updateOrdersData(state,action);
    },
    "updateOrdersData": (state, action) => {
      console.log('in updateOrdersDtta');
      console.log(action.payload)
      state.ordersData = action.payload;
      state.Processing = false;
      if (action.payload.length < 1) {toast('No Results Found')};
    },
    "getData": (state, action) => {
     console.log(action.payload);
     state.ordersData  = action.payload;
    },
    "orders/updateProcessing": (state, action) => {
      console.log('in orders/updateProcessing');
      updateProcessing(state,action);  
    },
    "updateProcessing": (state, action) => {
      console.log('in updateProcessing');
      state.Processing = action.payload;
      state.LoginMessage = (action.payload === false) ? 'Login Failed' : '';
    },
    "showRow": (state, action) => {
      state.displayRow = action.payload;
    },
    "completeResendingOrder" : (state, action) => {
      console.log('in completresendingorder');
      console.log(action);
      state.Processing = false;
      if (action.payload == '200') {
        state.ErrorMessage = 'Resend Successful';
        toast.success('Resend Successful');
      }
      else
      {
        state.ErrorMessage = 'Resend Failed';
        toast.error('Resend Failed');
      }

    },

  },
});

export const { 
  updateProcessing, 
  completeResendingOrder,
  updateOrdersData,
  clearOrdersData,
  getData,
  updateAccession,
  updateMRN, 
  Processing, 
  ErrorMessage,
  showRow 
} = ordersSlice.actions;

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched
export const getDataAsync = (searchMRN,searchAccession,jwt,requestType) => dispatch => {
  if ((searchMRN.length < 2) && (searchAccession.length < 2)) {
    toast.error('Must search with two or more characters in MRN or Accession #');
    return;
  }
  dispatch(updateProcessing(true));
  dispatch(getDataAPI({searchMRN,searchAccession,jwt,requestType}))

};

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectOrdersData = state => state.orders;

export const resendAsync = (id,messageType) => dispatch => {
  console.log(`resend type is ${messageType}`);
  dispatch(resendViaJson({id,messageType}));
}

export const resendViaJson = createAsyncThunk(
  'loginAPIcall', 
  async (Payload,thunkAPI ) => {
  try {
    const { jwt } = thunkAPI.getState().login
    thunkAPI.dispatch(updateProcessing(true));
    thunkAPI.dispatch(clearOrdersData([]));
    const id  = Payload.id;
    const messageType = Payload.messageType;

    const options = {
      'mode' : 'cors',
      'method' : 'get',
      headers: { 
        "Authorization" : `Bearer ${jwt}`,  
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
  			'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    };
  console.log(options);
  console.log(`resend type is ${messageType}`);
  let url = '';
  if (messageType == 'order') {
    url = `${window.configs.api_server}/resendORM?id=${id}`;
  }
  else if (messageType == 'priorORU'){
    url = `${window.configs.api_server}/resendPriorORU?id=${id}`;
  }
  console.log(url);

  let response = await fetch(url,options)
  response = await response
  console.log (JSON.stringify(response));
  console.log(`response from resending order is ${response.status}`);
  thunkAPI.dispatch(completeResendingOrder(response.status));
 
  } catch (error) {
    console.error(error);
  }
  return;
})



export const getDataAPI = createAsyncThunk(
  'loginAPIcall', 
  async (Payload,thunkAPI) => {
  try {

    thunkAPI.dispatch(updateProcessing(true));
    thunkAPI.dispatch(clearOrdersData([]));

    let { searchMRN, searchAccession, jwt, requestType } = Payload;
 

    console.log(Payload);
    const options = {
      'mode' : 'cors',
      'method' : 'get',
      headers: { 
        "Authorization" : `Bearer ${jwt}`,  
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
  			'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    };

console.log(options);
  let url = ''
  if (requestType === 'orders') {
    url = `${window.configs.api_server}/list/orders?mrn=${searchMRN}&accessionNumber=${searchAccession}`;
  }
  else if (requestType === 'results') {
    url = `${window.configs.api_server}/list/results?mrn=${searchMRN}&accessionNumber=${searchAccession}`;
  }
  else if (requestType === 'ph_prefetch') {
    url = `${window.configs.api_server}/post_PH_Prefetch/?mrn=${searchMRN}&accessionNumber=${searchAccession}`;
  }
  else if (requestType === 'ph_orm') {
    url = `${window.configs.api_server}/post_PH_ORM/?mrn=${searchMRN}&accessionNumber=${searchAccession}`;
  }
  else if (requestType === 'priorResults') {
    url = `${window.configs.api_server}/list/priorORU/?mrn=${searchMRN}&accessionNumber=${searchAccession}`;
  }
  else if (requestType === 'm7Study') {
    url = `${window.configs.api_server}/list/searchMach7Studies/?mrn=${searchMRN}&accessionNumber=${searchAccession}`;
  }

  

  
  

  console.log(url);

  let response = await fetch(url,options)
  response = await response
  response = await response.json();
  thunkAPI.dispatch(updateOrdersData(response));
  thunkAPI.dispatch(updateProcessing(false));

 
  } catch (error) {
    console.error(error);
  }

  return;
})

export default ordersSlice.reducer;
